import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import SideBar from '../Components/Sidebar';
import Pageheader from './Container/PageHeader/Pageheader';
import SubscriptionPage from './SubscriptionPage';
import BillingInfo from './BillingInfo';
import './Settings.css';
import './SubscriptionPage.css';

const SETTINGS_TABS = [
    { id: 'subscription', label: 'Subscription', path: '/settings/subscription' },
    { id: 'billinginfo', label: 'Billing Info', path: '/settings/billinginfo' },
];

const Settings = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const activeTab = location.pathname === '/settings/billinginfo' ? 'billinginfo' : 'subscription';

    useEffect(() => {
        if (location.pathname === '/settings') {
            navigate('/settings/subscription', { replace: true });
        }
    }, [location.pathname, navigate]);

    return (
        <div className="settings-wrapper">
            <SideBar />
            <div className="settings-content">
                <Pageheader pageTitle="Settings" />

                <div className="settings-nav">
                    {SETTINGS_TABS.map((tab) => (
                        <button
                            key={tab.id}
                            type="button"
                            className={`settings-nav-btn ${activeTab === tab.id ? 'settings-nav-btn-active' : ''}`}
                            onClick={() => navigate(tab.path)}
                        >
                            {tab.label}
                        </button>
                    ))}
                </div>

                <div className="settings-body">
                    {activeTab === 'subscription' && <SubscriptionPage embedded />}
                    {activeTab === 'billinginfo' && <BillingInfo />}
                </div>
            </div>
        </div>
    );
};

export default Settings;
